<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>
      {{titleinfo}}
    </div>
    <div class="content">
      <div class="set_flexwrap">
        <div class="flex_wrap">
          <el-form ref="form" :rules="rules" :model="formdata" label-width="120px">
            <div class="form_splititem">商品类别</div>
            <el-form-item>
              <el-radio-group v-model="formdata.type">
                <el-radio
                        v-for="(item,index) in goodtype"
                        :label="item.value"
                        :key="index"
                >{{item.label}}
                </el-radio>
              </el-radio-group>
              <p>
                如果是VIP会员、充值、录制课程、音频、视频等商品，请选择"虚拟商品"
              </p>
            </el-form-item>
            <div class="form_splititem">基本信息</div>
            <el-form-item label="商品名称" prop="goods_name">
              <el-input type="text" v-model="formdata.goods_name" maxlength="30" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="商品分类">
              <el-select
                      v-model="formdata.cat_label"
                      placeholder="请选择分类"
                      class="w555"
                      popper-class="whd-select-dropdown"
                      multiple
                      @remove-tag="removeTag"
              >
                <el-option :value="formdata.cat_id" style="height: auto">
                  <el-tree
                          :data="cateoptions"
                          show-checkbox
                          node-key="id"
                          ref="tree"
                          :default-checked-keys="formdata.cat_id"
                          :check-strictly="true"
                          highlight-current
                          :props="defaultProps"
                          @check-change="handleCheckChange"
                  ></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品图片" prop="album">
              <div v-if="formdata.album.length>0">
                <draggable v-model="formdata.album" :options="{draggable:'.draggableItem',animation: 150}"
                            :move="getdata"
                           @update="datadragEnd" class="draggable-body-list whd-draggable-list">
                  <transition-group class="draggable-body">
                    <div v-for="(item,index) in formdata.album" :key="item" class="draggableItem" 
                         :style="{backgroundImage:'url('+item+')',backgroundSize:'cover',backgroundPosition:'center'}"
                         :class="currentindex==index?'activedraggable':''" @click.stop="indexLine(index)">
                      <i class="el-icon-circle-close" @click="detelFn(index)"></i>
                    </div>
                  </transition-group>
                </draggable>
              </div>
              <div class="addicon">
                <div class="el-upload el-upload--text" @click="showCropper">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
                <div class="el-upload__tip">第一张默认为封面,可以拖拽图片调整顺序，最多上传5张，尺寸640*640比例，大小10M以内。</div>
              </div>              
            </el-form-item>
            <el-form-item label="介绍视频">
              <el-upload
                      class="addicon"
                      :action="uploadvideourl"
                      :data="data_"
                      :show-file-list="false"
                      :limit="1"
                      :on-success="handlevideoSuccess"
                      :before-upload="beforevideoUpload"
              >
                 <div v-if="formdata.video!==''">
                   <video
                           :src="formdata.video"
                           class="avatar"
                           controls="controls"
                   >您的浏览器不支持视频播放
                   </video>
                   <span class="detelBox" @click.stop="handlevideoRemove">删除</span>
                 </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div
                        slot="tip"
                        class="el-upload__tip"
                >介绍视频默认放在商品主图中第一屏，如有需要请上传，最多上传一个（仅支持5M以内的MP4格式）
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item class="whd-form-item" label="产品详情图片" prop="goods_detail">
              <uploaddrag v-if="formdata.goods_detail"
                      :picture="formdata.goods_detail"
                      @uploadsucess="uploaddetail"
                      limit="25"
                      ref="pictures"
              >
                <div slot="tipinfo" class="el-upload__tip">
                  上传与商品详情有关图片，可以拖拽图片调整顺序，最多上传25张，
                  图片宽高均不超过4000，宽不低于640,宽高比不超过1:25，单张不超过10M
                </div>
              </uploaddrag>
            </el-form-item>
            <el-form-item label="商品排序">
              <el-input type="text" v-model="formdata.order_desc" class="w160"></el-input>
            </el-form-item>
            <div class="form_splititem">价格库存</div>
            <template v-if="formdata.type===0">
              <!-- 支持线上支付 -->
              <div v-if="formdata.is_pay===0">
                <el-form-item label="规格设置">
                  <el-radio-group v-model="formdata.is_attr" @change="changeattr">
                    <el-radio
                            v-for="(item,index) in isattr"
                            :label="item.value"
                            :key="index"
                    >{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="销售单位" prop="unit">
                  <el-input type="text" v-model="formdata.unit" class="w160"></el-input>
                  <p class="el-upload__tip" style="line-height: 1.2">请输入计量单位，如件、套、斤等</p>
                </el-form-item>
                <!-- 单规格 -->
                <div v-if="formdata.is_attr===0">
                  <el-form-item label="库存" prop="goods_number">
                    <el-input type="text" v-model="formdata.goods_number " class="w160"></el-input>
                  </el-form-item>                  
                  <el-form-item prop="shop_price" label="积分">
                    <el-input type="text" v-model="formdata.shop_price" class="w105"></el-input>&nbsp;&nbsp;个                                    
                  </el-form-item>                 
                </div>
                <!-- 多规格 -->
                <div v-if="formdata.is_attr===1">
                  <el-form-item label="商品类目" prop="attr_cate">
                    <el-select
                            v-model="formdata.attr_cate"
                            class="w160"
                            placeholder="请选择"
                            @change="changeattrcate"
                    >
                      <el-option
                              v-for="(item,index) in attrcateoptions"
                              :key="index"
                              :label="item.name"
                              :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item 
                          v-for="(attritem,index)  in attrinfo"
                          :key="index"
                          :label="attritem.name"
                          required
                  >
                    <el-checkbox-group v-model="attritem.checkattrList" @change="getattrtable">
                      <el-checkbox
                              v-for="(subattritem,index) in attritem.attr"
                              :label="subattritem.id"
                              :key="index"
                      >{{subattritem.name}}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="市场价">
                    <el-input type="text" v-model="formdata.cost" class="w160"></el-input>
                  </el-form-item>
                  <el-table :data="attrtable" border style="width: 100%" v-if="tablehead.length>0">
                    <el-table-column
                            min-width="80"
                            :label="hitem.label"
                            v-for="(hitem,index) in tablehead"
                            :key="index"
                    >
                      <template slot-scope="scope">{{scope.row[hitem.label].name}}</template>
                    </el-table-column>
                    <el-table-column min-width="220" align="right">
                      <template slot="header" slot-scope="scope">
                        <div class="header_label w80 whd-tright">售价</div>
                        <el-input v-model="attr_price" class="w100" size="mini" style="margin: 0 8px" />
                        <el-dropdown size="mini" class="w65" @command="handlePriceCommand">
                          <span class="el-dropdown-link">
                            应用
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="a">应用所有规格</el-dropdown-item>
                            <el-dropdown-item command="b">仅应用未填写</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </template>
                      <template slot-scope="scope">
                        <el-input
                                class="w160"
                                type="number"
                                v-model.number="scope.row.attr_price"
                                size="mini"
                        />&nbsp;&nbsp;积分
                      </template>
                    </el-table-column>
                    <el-table-column min-width="220" label="库存">
                      <template slot="header" slot-scope="scope">
                        <div class="header_label w80 whd-tright">库存</div>
                        <el-input v-model="attr_number" class="w100" size="mini" style="margin: 0 8px"></el-input>
                        <el-dropdown size="mini" class="w65" @command="handleNumberCommand">
                          <span class="el-dropdown-link">
                            应用
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="a">应用所有规格</el-dropdown-item>
                            <el-dropdown-item command="b">仅应用未填写</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </template>
                      <template slot-scope="scope">
                        <el-input
                                type="number"
                                v-model.number="scope.row.attr_number"
                                class="w160"
                                size="mini"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="form_splititem">配送</div>
                <el-form-item label="物流设置">
                  <el-radio-group v-model="formdata.logistics_set">
                    <el-radio
                            v-for="(item,index) in logisticsset"
                            :label="item.value"
                            :key="index"
                    >{{item.label}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="快递运费" v-if="formdata.logistics_set===0">
                  <el-radio-group v-model="formdata.shipping_set">
                    <el-radio :label="item.value" v-for="(item,index) in shippingset" :key="index">
                      <div class="radio_item" v-if="item.value===0">
                        {{item.label}}
                        <el-input type="text" v-model="formdata.shipping_fee" class="w160"></el-input>
                        <span>元(默认0元，即商品免运费)</span>
                      </div>
                      <div class="radio_item" v-if="item.value===1">
                        {{item.label}}
                        <el-select v-model="formdata.fre_id" class="w160" placeholder="请选择">
                          <el-option
                                  v-for="item in freoptions"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id"
                          ></el-option>
                        </el-select>
                        <el-button @click="queryfreight" class="ml10">刷新</el-button>
                        <el-button @click="createfreight">新建运费模板</el-button>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>                
                <el-form-item v-if="formdata.logistics_set===1">
                  <p>选择无需物流时，在购买时无需填写收货地址</p>
                  <p>可选择用户需要填写的内容:</p>
                  <el-checkbox v-model="formdata.shipping_name">用户姓名</el-checkbox>
                  <el-checkbox v-model="formdata.shipping_phone">联系方式</el-checkbox>
                </el-form-item>
              </div>
            </template>
            <template v-else>
              <el-form-item label="销售单位" prop="unit">
                <el-input type="text" v-model="formdata.unit" class="w160"></el-input>
              </el-form-item>
              <el-form-item label="库存" prop="goods_number">
                <el-input type="text" v-model="formdata.goods_number " class="w160"></el-input>
              </el-form-item>                  
              <el-form-item prop="shop_price" label="积分">
                <el-input type="text" v-model="formdata.shop_price" class="w105"></el-input>&nbsp;&nbsp;个                                   
              </el-form-item>                 
            </template>
            <div class="form_splititem">商品介绍</div>
            <el-form-item label="副标题">
              <el-input
                      type="textarea"
                      :autosize="{ minRows: 4}"
                      v-model="formdata.goods_brief"
                      maxlength="22"
                      placeholder="请输入商品简介"
                      show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="商品详情" class="mt-10">
              <el-input
                      type="textarea"
                      :autosize="{ minRows: 6}"
                      v-model="formdata.goods_desc"
                      maxlength="400"
                      placeholder="请输入商品详情文字介绍"
                      show-word-limit
              ></el-input>
            </el-form-item>
            <div class="form_splititem">上架状态</div>
            <el-form-item>
              <el-radio-group v-model="formdata.is_sale">
                <el-radio
                        v-for="(item,index) in issale"
                        :label="item.value"
                        :key="index"
                >{{item.label}}
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="savegood('form')" size="small" v-if="goodsType==2">复制新商品</el-button>
              <el-button type="primary" @click="savegood('form')" size="small">保存</el-button>
              <el-button @click="goback" size="small">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="preview_wrap">
          <div class="preview_wrap_body">
            <p class="preview_wrap_body_title">实时预览效果</p>
            <div class="preview_wrap_body_list">
              <img src="/static/img/smallheader.jpg" alt="" class="header-top-linepic">
              <div class="banner-list">
                <img :src="formdata.album[0]?formdata.album[0]:'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png'" alt="">
                <span>1/{{formdata.album.length}}</span>
              </div>
              <div class="preview_wrap_goods">
                <div class="weui-cell" style="padding: 0; align-items: flex-end;">
                  <div class="weui-cell__hd" style="font-size: 20px; color: red; font-weight: bold; line-height: 1">{{formdata.shop_price}}</div>
                  <div class="weui-cell__bd" style="font-size: 14px; color: #000;">积分</div>
                  <div class="weui-cell__ft" style="color: #bababa; font-size: 12px">已售0件</div>
                </div>            
                <p class="preview_wrap_goods_name">{{formdata.goods_name}}</p>
                <p class="preview_wrap_goods_info">{{formdata.goods_brief}}</p>
              </div>
              <div class="preview_wrap_orth">
                <p class="preview_wrap_p">
                  <span class="preview_wrap_p_sapn">选择</span>
                  <span class="preview_wrap_p_sapn_line">请选择型号</span>
                  <span class="preview_wrap_p_sapn_llast"><i class="el-icon-arrow-right"></i></span>
                </p>
              </div>
              <div class="preview_wrap_desc">
                <p class="preview_wrap_desc_title">产品介绍</p>
                <div class="preview_wrap_desc_info">
                  <div class="preview_wrap_desc_info_word" v-html="formdata.goods_desc"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <corpper :visible.sync="corppervisible"
             v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="imgSize"></corpper>
  </div>
</template>
<script>
  import api from "@/api.js";
  import uploaddrag from "@/components/uploaddrag.vue";
  import corpper from "@/components/dialog/corpper.vue";
  import draggable from 'vuedraggable';
  import { pagination } from "@/util/util.js";
  import {
    goodtype,
    issale,
    logisticsset,
    commset,
    commtype,
    isattr,
    ispay,
    showtype,
    shippingset
  } from "@/util/util.js";

  export default {
    name: "addOrEditGoods",
    components: {
      uploaddrag,
      corpper,
      draggable
    },
    data() {
      return {
        data_: {token: sessionStorage.getItem("token")},
        imgSize: 0,
        corppervisible: false,
        currentindex: 0,
        titleinfo: "添加商品",
        uploadvideourl: api.uploadTokenVideo,
        goodtype: goodtype,
        issale: issale,
        logisticsset: logisticsset,
        commset: commset,
        commtype: commtype,
        isattr: isattr,
        ispay: ispay,
        showtype: showtype,
        shippingset: shippingset,
        formdata: {
          type: 0,
          goods_name: "",
          cat_id: [],
          cat_label: [],
          album: [],
          video: "",
          goods_detail: [],
          order_desc: "",
          is_pay: 0,
          is_attr: 0,
          unit: "",
          cost: "",
          shop_price: "",
          goods_number: "",
          comm_type: 0,
          commission: "",
          comm_set: 0,
          comm_outside: 50,
          outside: "",
          comm_inside: 50,
          inside: "",
          logistics_set: 0,
          shipping_set: 0,
          shipping_fee: "",
          fre_id: "",
          shipping_name: "",
          shipping_phone: "",
          is_sale: 0,
          show_type: "",
          show_price: "",
          reference: "",
          reference_price: "1万-10万",
          reference1: "参考价格",
          reference2: "价格面议",
          attr_cate: "",
          goods_brief: "",
          goods_desc: ""
        },
        cateoptions: [],
        freoptions: [],
        attrcateoptions: [],
        imageUrl: "",
        checkattrList: [],
        attrinfo: [],
        tablehead: [],
        attr_price: "",
        attr_number: "",
        attrtable: [],
        id: "",
        lock: true,
        attremptycount: 0,
        defaultProps: {
          value: "id",
          label: "name",
          children: "child"
        },
        rules: {
          goods_name: [
            {required: true, message: "请输入商品名称", trigger: "blur"}
          ],
          album: [
            {required: true, message: "请上传产品图片", trigger: "change"}
          ],
          goods_detail: [
            {required: true, message: "请上传产品详情图片", trigger: "change"}
          ],
          unit: [{required: true, message: "请输入销售单位", trigger: "blur"}],
          goods_number: [
            {required: true, message: "请输入库存", trigger: "blur"}
          ],
          attr_cate: [
            {required: true, message: "请选择商品类目", trigger: "change"}
          ],      
          shop_price: [{required: true, message: "请输入积分", trigger: "blur"}]
        },
        goodsType: null,
        drawer: false,    // 是否显示表单列表
        formList: [],     // 表单列表
        form_id: "",      // 选中的表单  
        form_name: "",    // 表单名称
        form_btn: "",     // 按钮名称
        loading: true, 
        page: {         
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        }  
      };
    },
    created() {
      // 查询分类
      this.querycatelist();
      // 查询运费模板
      this.queryfreight();      
      // 查询规格分类
      this.queryattrcatelist();
      this.id = this.$route.query.id;
      this.goodsType = this.$route.query.type;
      if (this.id) {
        let titleinfo = "编辑商品"
        if(this.goodsType === 2){
          titleinfo = "复制商品"
        }
        this.titleinfo = titleinfo;
        // 查询详情
        this.querydetail();
      }
    },
    methods: {
      changetype() {
        this.formdata.cost = "";
        // this.formdata.shop_price = "";
      },
      // 删除多选分类
      removeTag(key) {
        let res = this.$refs.tree.getCheckedNodes();
        let ids = [];
        res.forEach((item, sindex) => {
          if (this.formdata.cat_label.indexOf(item.name) !== -1) {
            ids.push(item.id);
          }
        });
        this.formdata.cat_id = ids;
        this.$refs.tree.setCheckedKeys(ids);

      },
      getcheckedcate() {
        let catlabel = [];
        let catid = [];
        this.formdata.cat.forEach((item, sindex) => {
          if (this.formdata.cat_label === item.name) {
            index = sindex;
          }
        });
      },
      // 树型分类
      handleCheckChange() {
        let res = this.$refs.tree.getCheckedNodes();
        let arrLabel = [];
        let arr = [];
        res.forEach(item => {
          arrLabel.push(item.name);
          arr.push(item.id);
        });
        this.formdata.cat_id = arr;
        this.formdata.cat_label = arrLabel;
      },
      // 查询编辑详情
      querydetail() {
        let params = {
          goods_id: this.id
        };
        let apiHttp_ = api.points_detail
        if(this.goodsType === 2){
          apiHttp_ = api.points_copy
        }
        this.axios
            .post(apiHttp_, params)
            .then(response => {
              if (response.data.code == 0) {
                this.formdata.type = response.data.info.type;
                this.formdata.goods_name = response.data.info.goods_name;
                this.formdata.goods_number = response.data.info.goods_number;
                this.formdata.cat_id = response.data.info.cate_id;
                this.formdata.cat_label = response.data.info.cat_id;
                this.formdata.album = response.data.info.album || [];
                this.formdata.video = response.data.info.video;
                this.formdata.goods_detail = response.data.info.goods_detail || [];
                this.formdata.order_desc = response.data.info.order_desc;
                this.formdata.is_pay = response.data.info.is_pay;
                this.formdata.is_attr = response.data.info.is_attr;
                this.formdata.unit = response.data.info.unit;
                this.formdata.cost = response.data.info.cost;
                this.formdata.shop_price = response.data.info.shop_price;
                this.formdata.attr_cate = response.data.info.attr_cate;
                this.formdata.show_price = response.data.info.show_price + "";
                this.formdata.show_type = response.data.info.show_type;
                if (this.formdata.show_type === 0) {
                  this.formdata.reference1 = response.data.info.reference;
                  this.formdata.reference_price = response.data.info.reference_price;
                } else if (this.formdata.show_type === 1) {
                  this.formdata.reference2 = response.data.info.reference;
                }

                this.formdata.comm_type = response.data.info.comm_type;
                this.formdata.commission = response.data.info.commission;
                this.formdata.comm_set = response.data.info.comm_set;
                this.formdata.comm_outside = response.data.info.comm_outside;
                this.formdata.comm_inside = response.data.info.comm_inside;
                this.formdata.is_sale = response.data.info.is_sale;
                this.formdata.logistics_set = response.data.info.logistics_set;
                this.formdata.shipping_set = response.data.info.shipping_set;
                this.formdata.fre_id = response.data.info.fre_id;
                this.formdata.shipping_fee = response.data.info.shipping_fee;
                this.formdata.goods_brief = response.data.info.goods_brief;
                this.formdata.goods_desc = response.data.info.goods_desc;
                this.formdata.shipping_name =
                    response.data.info.shipping_name === 0 ? false : true;
                this.formdata.shipping_phone =
                    response.data.info.shipping_phone === 0 ? false : true;
                this.queryattrlist(
                    this.formdata.attr_cate,
                    this.getcheckattrids(response.data.attr)
                );
                this.createdittable(response.data.goods_attr);
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 编辑规格表格数据
      createdittable(goodsattrlist) {
        let result = [];
        this.tablehead = [];
        goodsattrlist.forEach((gitem, gindex) => {
          let rowdata = {
            attr_number: gitem.number,
            attr_price: gitem.price
          };
          if (gitem.attr_value && gitem.attr_value.length) {
            gitem.attr_value.forEach(aitem => {
              if (gindex === 0) {
                this.tablehead.push({
                  label: aitem.spec_name
                });
              }
              rowdata[aitem.spec_name] = {
                id: aitem.item_id,
                name: aitem.item_name,
                spec_id: aitem.spec_id
              };
            });
          }
          result.push(rowdata);
        });
        this.attrtable = result;
      },
      // 获取选中的规格id
      getcheckattrids(attr) {
        let ids = [];
        if (attr && attr.length) {
          attr.forEach(item => {
            ids.push(item.id);
          });
        }
        return ids;
      },
      // 查询分类
      querycatelist() {
        let params = {};
        this.axios
            .post(api.points_goods_cate_list, params)
            .then(response => {
              if (response.data.code == 0) {
                this.cateoptions = response.data.list || [];
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 多规格查询规格分类
      changeattr(val) {
        if (val === 1) {
          this.queryattrcatelist();
        }
      },
      // 查询规格分类列表
      queryattrcatelist() {
        let params = {};
        this.axios
            .post(api.points_attr_cate_list, params)
            .then(response => {
              if (response.data.code == 0) {
                this.attrcateoptions = response.data.list || [];
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 多规格查询规格分类列表
      changeattrcate(val) {
        if (val) {
          this.attrtable = [];
          this.tablehead = [];
          this.attr_price = "";
          this.attr_number = "";
          this.queryattrlist(val);
        }
      },
      // 规格名称列表
      queryattrlist(cateid, checkids) {
        let params = {
          cate_id: cateid
        };
        this.axios
            .post(api.points_attr_list, params)
            .then(response => {
              if (response.data.code == 0) {
                this.attrinfo = this.transformattr(response.data.list, checkids);
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 转换规格属性
      transformattr(list, checkids) {
        let res = [];
        if (list && list.length) {
          list.forEach(item => {
            let attritem = {
              name: item.name,
              attr: item.attr,
              checkattrList: []
            };
            let checkedattr = this.ischeckedattrid(item.attr, checkids);
            if (checkedattr.index !== -1) {
              attritem.checkattrList = [...checkedattr.ids];
            }
            res.push(attritem);
          });
        }
        return res;
      },
      // 是否存在选择的规格属性id
      ischeckedattrid(attr, checkids) {
        let result = {
          index: -1,
          ids: []
        };
        if (attr && attr.length) {
          attr.forEach((item, index) => {
            if (checkids && checkids.length && checkids.indexOf(item.id) !== -1) {
              result.ids.push(item.id);
              result.index = index;
            }
          });
        }
        return result;
      },
      // 获取规格属性列表
      getattrtable() {
        let result = [];
        this.tablehead = [];
        if (this.attrinfo) {
          this.attrinfo.forEach(attritem => {
            // 获取表头数据
            if (attritem.checkattrList.length) {
              this.tablehead.push({
                label: attritem.name
              });
            }
            // 获取选中属性数据
            let res = [];
            attritem.attr.forEach(item => {
              if (attritem.checkattrList.indexOf(item.id) !== -1) {
                let itemobj = {
                  attr_number: "",
                  attr_price: ""
                };             
                itemobj[attritem.name] = {
                  id: item.id,
                  name: item.name,
                  spec_id: item.spec_id
                };  
                res.push(itemobj);
              }
            });
            if (res && res.length) {
              if (this.attrtable.length > 0) {
                this.attrtable.forEach(item => {
                  res.forEach(itema => {
                    for (let i in item) {
                      if (i === "attr_number" || i === "attr_price") {

                      } else {
                        for (let j in itema) {
                          if (i === j && item[i].name === itema[j].name) {
                            itema.attr_number = item.attr_number;
                            itema.attr_price = item.attr_price; 
                          }
                        }

                      }
                    }
                  })
                })
              }
              result.push(res);
            }
          });
        }

        this.getattrtabledata(result);
      },
      // 应用价格
      handlePriceCommand(command) {
        this.settingattrtable(command, "p");
      },
      // 应用库存
      handleNumberCommand(command) {
        this.settingattrtable(command, "n");
      },
      // 设置规格售价，库存
      settingattrtable(val, type) {
        this.attrtable.forEach(row => {
          if (type == "p") {
            if (val === "a") {
              row.attr_price = this.attr_price;
            } else {
              if (row.attr_price === "") {
                row.attr_price = this.attr_price;
              }
            }
          }
          if (type == "n") {
            if (val === "a") {
              row.attr_number = this.attr_number;
            } else {
              if (row.attr_number === "") {
                row.attr_number = this.attr_number;
              }
            }
          }
        });
      },
      // 生成规格表格
      getattrtabledata(arr) {
        let result = [];
        let attr = this.attrtable;
        let thead = this.tablehead;
        arr.forEach(arritem => {      
          if (result.length == 0) {
            result = arritem;
          } else {      
            let emptyresult = [];
            result.forEach(item => {
              arritem.forEach(value => {
                let obj = {...item, ...value}
                if (item.attr_number) {obj.attr_number = item.attr_number};
                if (item.attr_price) {obj.attr_price = item.attr_price};
                emptyresult.push(obj);
              });
            });
            result = emptyresult;
          }
        });
        this.attrtable = result;
      },
      // 产品图片
      detelFn(index) {
        this.formdata.album.splice(index, 1)
      },
      indexLine(index) {
        this.currentindex = index
      },
      datadragEnd(evt) {
        this.currentindex = evt.newIndex
      },
      getdata(data) {
      },
      imgAddBack(option) {
        this.formdata.album.push(option)
      },
      showCropper() {
        this.corppervisible = true
      },
      uploadalbum(val) {
        this.formdata.album = val;
      },
      // 产品详情
      uploaddetail(val) {
        this.formdata.goods_detail = val;
      },
      handlevideoSuccess(res, file) {
        if (res.code === 0) {
          this.formdata.video = res.path;
        } else {
          this.$message.error(res.msg);
        }
        this.loadingStatus.close();
      },
      handlevideoRemove() {
        this.formdata.video = ''
      },
      beforevideoUpload(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (["video/mp4"].indexOf(file.type) == -1) {
          this.$message.error("请上传正确的视频格式");
          return false;
        }
        if (!isLt5M) {
          this.$message.error("上传视频大小不能超过5MB哦!");
          return false;
        }
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
      },
      // 查询运费模板
      queryfreight() {
        let params = {};
        this.axios
            .post(api.goods_freight, params)
            .then(response => {
              if (response.data.code == 0) {
                this.freoptions = response.data.list || [];
              } else {
              }
            })
            .catch(response => {
            });
      },      
      // 保存
      savegood(formName) {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            let params = {};
            if (this.formdata.type === 1) {
              params = this.getvgoodparams();
            }
            if (this.formdata.type === 0) {
              params = this.getgoodparams();

              // 支持线上支付并且多规格项判断是否必填;
              if (this.formdata.is_pay === 0 && this.formdata.is_attr === 1) {
                if (params.attr_data && params.attr_data.length === 0) {
                  this.$message({
                    message: "请选择商品类目项",
                    type: "warning"
                  });
                  return false;
                } else {
                  if (this.attremptycount > 0) {
                    this.$message({
                      message: "售价库存不能为空",
                      type: "warning"
                    });
                    return false;
                  }
                }
              }           
            }

            if (this.lock) {
              this.lock = false;
              if (this.id) {
                if (this.goodsType === 2) {
                  this.submitsave(params);
                } else {
                  this.submiteditsave(params);
                }
              } else {
                this.submitsave(params);
              }
            }
          } else {
            return false;
          }
        });
      },
      // 虚拟商品
      getvgoodparams() {
        let params = {
          type: this.formdata.type,
          goods_name: this.formdata.goods_name,
          cat_id: this.formdata.cat_id,
          album: this.formdata.album.join(","),
          video: this.formdata.video,
          goods_detail: this.formdata.goods_detail.join(","),
          order_desc: this.formdata.order_desc,
          is_sale: this.formdata.is_sale,
          goods_brief: this.formdata.goods_brief,
          goods_desc: this.formdata.goods_desc,
          unit: this.formdata.unit,
          shop_price: this.formdata.shop_price,
          goods_number: this.formdata.goods_number
        };
        return params;
      },
      // 实体商品
      getgoodparams() {
        let params = {
          type: this.formdata.type,
          goods_name: this.formdata.goods_name,
          cat_id: this.formdata.cat_id,
          album: this.formdata.album.join(","),
          video: this.formdata.video,
          goods_detail: this.formdata.goods_detail.join(","),
          order_desc: this.formdata.order_desc,
          is_sale: this.formdata.is_sale,
          goods_brief: this.formdata.goods_brief,
          goods_desc: this.formdata.goods_desc,
          is_pay: this.formdata.is_pay
        };
        // 仅线上展示
        if (this.formdata.is_pay === 1) {
          params.show_type = this.formdata.show_type;
          if (this.formdata.show_type === 0) {
            params.reference = this.formdata.reference1;
            params.reference_price = this.formdata.reference_price;
          } else {
            params.reference = this.formdata.reference2;
            params.reference_price = "";
          }
        }
        // 支持线上支付
        if (this.formdata.is_pay === 0) {
          params.is_attr = this.formdata.is_attr;
          params.unit = this.formdata.unit;

          // 单规格
          if (this.formdata.is_attr === 0) {
            params.cost = this.formdata.cost;
            params.shop_price = this.formdata.shop_price;
            params.show_price = this.formdata.show_price;
            params.goods_number = this.formdata.goods_number;
          }
          // 多规格
          if (this.formdata.is_attr === 1) {
            params.attr_cate = this.formdata.attr_cate;
            params.cost = this.formdata.cost;
            params.attr_data = this.getattrsetting();
          }

          // 提成
          params.comm_type = this.formdata.comm_type;
          params.commission = this.formdata.commission;

          // 分销
          params.comm_set = this.formdata.comm_set;

          if (this.formdata.comm_set === 1) {
            params.comm_outside = this.formdata.comm_outside;
            params.comm_inside = this.formdata.comm_inside;
          }
          // 物流
          params.logistics_set = this.formdata.logistics_set;
          if (this.formdata.logistics_set === 0) {
            params.shipping_set = this.formdata.shipping_set;
            if (this.formdata.shipping_set === 0) {
              params.shipping_fee = this.formdata.shipping_fee;
              params.fre_id = "";
            }
            if (this.formdata.shipping_set === 1) {
              params.fre_id = this.formdata.fre_id;
              params.shipping_fee = "";
            }
          }
          if (this.formdata.logistics_set === 1) {
            params.shipping_name = this.formdata.shipping_name === true ? 1 : 0;
            params.shipping_phone = this.formdata.shipping_phone === true ? 1 : 0;
          }
        }
        return params;
      },

      // 多规格设置数据参数
      getattrsetting() {
        let result = [];
        this.attremptycount = 0;
        if (this.attrtable && this.attrtable.length > 0) {
          this.attrtable.forEach(item => {
            if (item.attr_price === "" || item.attr_number === "") {
              this.attremptycount++;
            }
            var setitem = {
              attr_price: item.attr_price,
              attr_number: item.attr_number
            };
            setitem.attr_value = {};
            if (this.tablehead && this.tablehead.length) {
              this.tablehead.forEach(hitem => {
                setitem.attr_value[item[hitem.label].spec_id] =
                    item[hitem.label].id;
              });
            }
            result.push(setitem);
          });
        }
        return result;
      },
      // 提交保存
      submitsave(params) {
        this.axios
            .post(api.points_add, params)
            .then(response => {
              this.lock = true;
              if (response.data.code == 0) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.goback();
              } 
            })
            .catch(response => {
              this.lock = true;
            });
      },
      // 提交保存
      submiteditsave(params) {
        // goodsType 1 编辑 2 复制商品
        let message_ = "保存成功"
        if (this.goodsType === 2) {
          message_ = "复制成功"
        }
        params.goods_id = this.id;
        this.axios
            .post(api.points_edit, params)
            .then(response => {
              this.lock = true;
              if (response.data.code == 0) {
                this.$message({
                  message: message_,
                  type: "success"
                });
                this.goback();
              } 
            })
            .catch(response => {
              this.lock = true;
            });
      },
      goback() {
        this.$router.go(-1);
      },
      // 前往配置
      goset() {
        let routeData = this.$router.resolve({
          name: "payment"
        });
        window.open(routeData.href, "_blank");
      },
      // 前往运费模板
      createfreight() {
        let routeData = this.$router.resolve({
          name: "createFreight"
        });
        window.open(routeData.href, "_blank");
      }
    }
  }
</script>